import { FC } from 'react';
import type { Breadcrumb } from 'src/common/types/api/v4/boats/search';
import DlpBreadcrumbs from 'src/search/components/DlpBreadcrumbs';
import styles from './DlpBreadcrumbsSection.module.scss';

type DlpBreadcrumbsSectionProps = {
  breadcrumbs: Breadcrumb[];
};

const DlpBreadcrumbsSection: FC<DlpBreadcrumbsSectionProps> = ({ breadcrumbs }) => (
  <div className={styles.root}>
    <DlpBreadcrumbs breadcrumbs={breadcrumbs} separator="caret-right" />
  </div>
);

export default DlpBreadcrumbsSection;
